import Head from 'next/head';
import { memo } from 'react';

interface SEOConfig {
  title: string,
  keywords: string,
  description: string,
}

interface ShareConfigItem {
  qrCodeUrl?: string,
  shareImg: string,
  shareUrl: string,
  universeUrl?: string,
}

interface ShareConfig {
  default?: ShareConfigItem,
  facebook?: ShareConfigItem,
  twitter?: ShareConfigItem,
  telegram?: ShareConfigItem,
  wechat?: ShareConfigItem,
}

interface CustomHeadProps {
  seo: SEOConfig,
  share: ShareConfig,
  children?: React.ReactNode,
}

export default memo(function CustomHead(props: CustomHeadProps) {

  const { seo, share, children } = props
  const { facebook, twitter } = share
  const def = share.default

  return (
    <Head>
      <title>{seo.title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"></meta>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"></meta>
      <meta name="keywords" content={seo.keywords} />
      <meta name="description" content={seo.description} />
      <meta name="renderer" content="webkit" />
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />

      {def ? (
        <>
          <meta property="type" content="article" />
          <meta property="title" content={seo.title} />
          <meta property="description" content={seo.description} />
          <meta property="image" content={def.shareImg} />
          <meta itemProp="image" content={def.shareImg} />
        </>
      ) : ''}

      {facebook ? (
        <>
          <meta property="og:type" content="website" />
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:image" content={facebook.shareImg} />
          <meta property="og:url" content={facebook.shareUrl}></meta>
        </>
      ) : ''}

      {twitter ? (
        <>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={seo.title} />
          <meta name="twitter:description" content={seo.description} />
          <meta name="twitter:image:alt" content="Doodles" />
          <meta name="twitter:image" content={twitter.shareImg} />
        </>
      ) : ''}

      {children}
    </Head>
  );
})
